import { Box, Card } from '@mui/material'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
import WTypography from 'Components/whiteTypography'
import { Line } from 'react-chartjs-2'
import CustomButton from 'Components/CustomButton/CustomButton'
import moment from 'moment'
import EmptyDataShortcut from './EmptyDataShortcut'

function TempsFormation({ oldData, updateReports }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [viewType, setViewType] = useState('month')
  const [data, setRevData] = useState({
    labels: ['2021', '2022', '2023', '2024'],
    show: true,
    datasets: [
      {
        data: [4, 5, 3, 4],
        borderColor: ['#c1daf1'],
        backgroundColor: ['#c1daf1'],
        borderWidth: 5,
      },
    ],
  })

  const optionsbar = {
    indexAxis: 'x',
    aspectRatio: 1.05,

    elements: {
      bar: {
        borderWidth: 2,
      },
    },
    responsive: true,
    scales: {
      x: {
        ticks: {
          color: 'white',
          callback: function (e) {
            let label = ''
            if (viewType === 'year') label = data.labels[e]
            else label = moment(data.labels[e]).format('MMM YY')
            return label
          },
        },
        grid: {
          color: 'rgba(255,255,255,0.1)',
        },
      },
      y: {
        beginAtZero: true,
        ticks: {
          color: 'white',
        },
        grid: {
          color: 'rgba(255,255,255,0.1)',
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      datalabels: {
        display: false,
        color: 'white',
        formatter: (val, ctx) => ctx.chart.data.labels[ctx.dataIndex],
      },
      tooltips: {
        callbacks: {
          label: function (tooltipItem) {
            return tooltipItem.yLabel
          },
        },
      },
    },
  }
  useEffect(() => {
    setRevData({
      labels: oldData.by_month.label,
      show: oldData.by_month.show,
      datasets: [
        {
          data: oldData.by_month.data,
          borderColor: ['#c1daf1'],
          backgroundColor: ['#c1daf1'],
          borderWidth: 5,
        },
      ],
    })
  }, [])

  const yearData = (type) => {
    if (type === 'month') {
      setViewType('month')
      setRevData({
        labels: oldData.by_month.label,
        show: oldData.by_month.show,
        datasets: [
          {
            data: oldData.by_month.data,
            borderColor: ['#c1daf1'],
            backgroundColor: ['#c1daf1'],
            borderWidth: 5,
          },
        ],
      })
    }
    if (type === 'year') {
      setViewType('year')
      setRevData({
        labels: oldData.by_year.label,
        show: oldData.by_year.show,
        datasets: [
          {
            data: oldData.by_year.data,
            borderColor: ['#c1daf1'],
            backgroundColor: ['#c1daf1'],
            borderWidth: 5,
          },
        ],
      })
    }
  }
  return (
    <>
      <Card className="dashboard_card__root1" sx={{ display: 'flex', flexDirection: 'column' }}>
        <Box className="dashboard_card__header1 no-drag">
          <WTypography component={'span'} variant="h6">
            {t('professionnelle.tempsFormationTitle') /* LAP-733 (GE022) */}
          </WTypography>
          <WTypography component={'span'} variant="h6">
            {parseFloat(oldData.current_month).toFixed(2)} H
          </WTypography>
        </Box>
        <Box className="dashboard_card__header1">
          <WTypography sx={{ color: '#ffffffa1' }} variant={'body2'}>
            {t('professionnelle.tempsFormationSubtitle') /* LAP-733 (GE022) */}
          </WTypography>
        </Box>
        <Box mt={1} minWidth={3} mb={1} height={'100%'}>
          {data.show ? (
            <Line data={data} options={optionsbar} />
          ) : (
            <EmptyDataShortcut
              title={t('professionnelle.emptyTitle') /* LAP-733 (GE022) */}
              description={t('professionnelle.tempsFormationDesc') /* LAP-733 (GE022) */}
            />
          )}
        </Box>

        <Box
          mt={1}
          className="dashboard_card__filters no-drag"
          sx={{ position: 'unset !important', width: '100%', pr: '0px !important' }}
        >
          <CustomButton onClick={(e) => yearData('year')} style={{ padding: 0 }}>
            {t('professionnelle.btnYear') /* LAP-733 (GE022) */}
          </CustomButton>
          <CustomButton onClick={(e) => yearData('month')} style={{ padding: 0 }}>
            {t('professionnelle.btnMonth') /* LAP-733 (GE022) */}
          </CustomButton>
        </Box>
      </Card>
    </>
  )
}

export default TempsFormation
